export const removeAtIndex = <T>(array: T[], index: number): T[] => {
	if (index < 0 || index >= array.length) {
		// Index out of bounds, return original
		return array.slice()
	}
	return [...array.slice(0, index), ...array.slice(index + 1)]
}

export const splitAt = <T>(arr: T[], index: number): [T[], T[]] => [
	arr.slice(0, index),
	arr.slice(index),
]
